module.exports = __webpack_public_path__ + "img/arrow-address.59842050.svg";